<template lang='pug'>
  .logo: h1
    | Healthy
    br
    | Computer
</template>

<script>
export default {name: 'Logo'}
</script>

<style scoped lang='stylus'>
.logo
  padding-left 23px
h1
  position relative
  font inherit
  color red
  &::before
    content ''
    display block
    position absolute
    top 6px
    left -23px
    width 13px
    height @width
    background-image url("data:image/svg+xml,%3Csvg width='13' height='13' viewBox='0 0 13 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect y='5.75' width='13' height='1.5' fill='red'/%3E%3Crect x='5.75' width='1.5' height='13' fill='red'/%3E%3C/svg%3E%0A")
  &::after
    content '_'
    animation blink 1800ms infinite

@keyframes blink
	0%
    opacity 0
	49%
    opacity 0
	50%
    opacity 1
</style>
